import { Expose } from "@nts/std/serialization";
import { BaseRootModel } from './base-root-model';
import type { IdentityInterface } from '@nts/std/interfaces';
import type { OCCModelInterface } from '@nts/std/interfaces';


export class OCCModel<TIdentity extends IdentityInterface> extends BaseRootModel<TIdentity> implements OCCModelInterface<TIdentity> {

  static override PROPERTY_LIST: string[] = [
    ...BaseRootModel.PROPERTY_LIST,
    'occ',
    'reservedData'
  ];

  @Expose()
  occ: string;

  @Expose()
  reservedData: string;

  // @Expose()
  // oCCV: string;

  // @Expose()
  // oCCVN: number;

}
